import React from 'react';
import { GridCol } from '@naf/grid';
import { TextVariant } from '@naf/text';
import { FooterLink } from '../FooterLink/FooterLink';
import { LinkListItem } from '../../../../../types/globalSettingsType';
import * as S from './FooterColumn.styles';

interface FooterColumnProps {
  column?: {
    header?: string;
    links?: LinkListItem[];
  };
}

const FooterColumn = ({ column }: FooterColumnProps) => {
  if (!column?.links?.length) return null;

  return (
    <GridCol s="12" m="12" l="4" xl="3">
      {column.header && <S.StyledHeader variant={TextVariant.Header3}>{column.header}</S.StyledHeader>}
      <S.LinkList>
        {column.links.map((link) => (
          <FooterLink key={`${link.title}-${link.key}`} link={link} />
        ))}
      </S.LinkList>
    </GridCol>
  );
};

export default FooterColumn;
